import React, { useMemo } from 'react';
import { pick, upperFirst } from 'lodash';
import { stringify } from 'querystring';

import { PromoCard } from 'components/partner/PromoCard';
import BellhopsPromo from 'assets/images/promos/bellhops.webp';
import HomeDepotPromo from 'assets/images/promos/home-depot.webp';
import MovingSuppliesPromo from 'assets/images/promos/moving-supplies.webp';

const withTruckPromos = (WrappedComponent) => {
	const WithTruckPromos = (props) => {
		const {
			isBellhopsMarket,
			searchLocation,
			queryParams,
			isTruckSerp,
			...rest
		} = props;

		const truckPromoProps = useMemo(() => {
			if (!isTruckSerp) {
				return {};
			}

			const promoCards = [
				<PromoCard
					key="www.sparefoot.com"
					href="https://www.sparefoot.com/moving-supplies.html"
					src={MovingSuppliesPromo}
					openNewTab={false}
				/>,
				<PromoCard
					key="www.homedepot.com"
					href="https://www.homedepot.com/b/Storage-Organization/N-5yc1vZas7e?AID=11210757&PID=8367506&cm_mmc=CJ-_-8367506-_-11210757&cj=true&sid=truckSerp"
					src={HomeDepotPromo}
					openNewTab={false}
				/>,
			];

			if (isBellhopsMarket && searchLocation) {
				const city = searchLocation.city.toLowerCase();
				const state = searchLocation.state.toLowerCase();
				const fullState = searchLocation.fullState.toLowerCase();
				const bellhopsParams = {
					city,
					state,
					utm_partner: 'sparefoot',
					utm_invoca: 'sparefoot1',
					promo_coupon_code: 'sparefoot5',
					movingTruck: 'movingTruck',
					location: `${upperFirst(city)}, ${searchLocation.state}`,
					...pick(queryParams, [
						'utm_source',
						'utm_campaign',
						'utm_content',
					]),
				};

				const url = `https://www.getbellhops.com/market/${city}-${fullState}/?${stringify(bellhopsParams)}`;

				promoCards.push(
					<PromoCard
						key="www.getbellhops.com"
						href={url}
						src={BellhopsPromo}
					/>,
				);
			}

			// Each key is the index at which to inject the ad/promo element
			const injectedComponents = promoCards.reduce(
				(components, card, index) => ({
					...components,
					[index * 2 + 2]: card,
				}),
				{},
			);

			return {
				injectedComponents,
				injectAllEvenIfNoContent: true,
			};
		}, [isBellhopsMarket, searchLocation, queryParams, isTruckSerp]);

		return (
			<WrappedComponent
				{...rest}
				isBellhopsMarket={isBellhopsMarket}
				searchLocation={searchLocation}
				queryParams={queryParams}
				isTruckSerp={isTruckSerp}
				{...truckPromoProps}
			/>
		);
	};

	return WithTruckPromos;
};

export default withTruckPromos;
